let _store = null;
let _i18n = null;

export function init ({ store, i18n }) {
  _store = store;
  _i18n = i18n;
}

export {
  _store as store,
  _i18n as i18n
};